import type { BatchData } from '../types';
import MetaField from './MetaField';

interface Props {
  data: BatchData;
  onPatch: (patch: Partial<BatchData>) => void;
  onFocusField: (fieldId: string | null) => void;
}

export default function QualityTestingCard({ data, onPatch, onFocusField }: Props) {
  return (
    <div className="card">
      <div className="card-header">
        <span className="card-title">Quality &amp; Testing</span>
      </div>
      <div className="card-body">
        <div className="field-grid fg-3">
          <MetaField label="Preservation efficacy" id="metaPreservation" placeholder="e.g. Challenge test pending" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Stability test date" id="metaStabilityDate" type="date" data={data} onPatch={onPatch} onFocusField={onFocusField} />
          <MetaField label="Safety / allergen notes" id="metaSafety" placeholder="e.g. Contains lavender — flag for sensitive skin" data={data} onPatch={onPatch} onFocusField={onFocusField} />
        </div>
      </div>
    </div>
  );
}
